
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[client]/preview/[agenda]",
      function () {
        return require("private-next-pages/[client]/preview/[agenda].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[client]/preview/[agenda]"])
      });
    }
  